import axios from "axios";
import { setupInterceptors } from "./interceptors";
import { API_BASE_URL } from "./endpoints";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  paramsSerializer: {
    indexes: null,
  },
});

setupInterceptors(api);

export default api;